import type { ParameterDimensionDefinitionInOut } from '@festina/configuration-general-types/configuration'
import { assertNotEmpty } from '@festina-life/core'

import { useParameterContext } from '../../../context/parameterContext'
import { ParameterDimensionTypeEditor } from './ParameterDimensionTypeEditor'
import { ParameterDimensionTypeViewer } from './ParameterDimensionTypeViewer'

type Props = {
  data: ParameterDimensionDefinitionInOut
}

export const ParameterDimensionTypeCell = ({ data }: Props) => {
  const { parameterDefinitionOperation } = useParameterContext()

  assertNotEmpty(parameterDefinitionOperation)

  const { isDraft } = parameterDefinitionOperation

  return isDraft ? (
    <ParameterDimensionTypeEditor data={data} isCentered />
  ) : (
    <ParameterDimensionTypeViewer data={data} isCentered />
  )
}
